// Renders ephemeral "Achievement unlocked!" toasts. Uses inline styles so it
// works regardless of which Tailwind classes are in the build. Called centrally
// from the API client whenever a response carries `new_achievements`.
export function showAchievementToasts(list) {
  if (!Array.isArray(list) || list.length === 0) return

  let container = document.getElementById('achievement-toasts')
  if (!container) {
    container = document.createElement('div')
    container.id = 'achievement-toasts'
    container.style.cssText =
      'position:fixed;top:16px;right:16px;z-index:60;display:flex;flex-direction:column;gap:8px;'
    document.body.appendChild(container)
  }

  list.forEach((a, i) => {
    const el = document.createElement('div')
    el.style.cssText =
      'background:#059669;color:#fff;padding:12px 16px;border-radius:12px;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.2);display:flex;align-items:center;gap:10px;' +
      'font-size:14px;max-width:300px;transform:translateX(120%);transition:transform .3s ease;'

    const icon = document.createElement('span')
    icon.style.fontSize = '22px'
    icon.textContent = a.icon || '🏆'

    const text = document.createElement('div')
    const head = document.createElement('div')
    head.style.fontWeight = '700'
    head.textContent = 'Achievement unlocked!'
    const title = document.createElement('div')
    title.textContent = a.title || ''
    text.append(head, title)

    el.append(icon, text)
    container.appendChild(el)

    requestAnimationFrame(() => { el.style.transform = 'translateX(0)' })
    setTimeout(() => {
      el.style.transform = 'translateX(120%)'
      setTimeout(() => el.remove(), 300)
    }, 5000 + i * 500)
  })
}
